import { QUERY_KEYS } from '@/shared/api';
import { queryOptions } from '@tanstack/react-query';
import { getUserProfile } from './v1';

export const authQueries = {
  session: () =>
    queryOptions({
      queryKey: [QUERY_KEYS.GET_USER_INFO],
      queryFn: getUserProfile,
      // 401은 getUserProfile 내부에서 null로 변환되므로 retry 의미 없음
      retry: false,
    }),
};
